import { render, staticRenderFns } from "./AsignadosMail.vue?vue&type=template&id=7bf912b0&"
import script from "./AsignadosMail.vue?vue&type=script&lang=js&"
export * from "./AsignadosMail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports